import './overlay.scss';

import Overlay from './Overlay';

export default Overlay;
